import { enableProdMode } from '@angular/core';
// import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

if (environment.production) {
	enableProdMode();

	if (window) {
		window.console.log = function () { };
		window.console.info = function () { };

		// window.console.log = function () { };
		// window.console.warn = function () { };
		// window.console.error = function () { };
		// window.console.info = function () { };
	}
}

platformBrowserDynamic().bootstrapModule(AppModule)
	.catch(err => console.error(err));
